import React from 'react';
import { Field } from 'redux-form';
import { Input } from 'components/UIForm';
import { findImg as FindImg } from 'theme/icon';
import styles from './styles.scss';
import Switch from './control/view_switch';
import { INavigate } from './files.interface';

export const Navigate: React.FC<INavigate> = ({ view, toggleTabularView, total }) => (
  <div className={styles.navigate}>
    <div className={styles.headerName}>
      <h2>Документы</h2>
      {total && <span className={styles.counter}>{total}</span>}
    </div>
    <Field
      name="name"
      component={Input}
      suffix={<FindImg alt="" />}
      style={{ width: 286 }}
      className={styles.docsSearch}
      placeholder="Поиск"
      allowClear
    />
    <div className={styles.buttons}>
      <Switch checked={view === 'grid'} handleChange={() => toggleTabularView(view === 'table' ? 'grid' : 'table')} />
    </div>
  </div>
);
